import {chatClient} from '../../config/get-stream';
import {
  Channel,
  ChannelAPIResponse,
  APIResponse,
  MessageResponse,
  UnknownType,
  Attachment,
  DeleteChannelAPIResponse,
  LiteralStringForUnion,
} from 'stream-chat';
import {CHANNEL_MESSAGING} from '../../utils/constants';

class ChannelServiceClass {
  public createChannel = ({
    name,
    members,
  }: {
    name: string;
    members: string[];
  }): Channel => {
    return chatClient.channel(CHANNEL_MESSAGING, {
      name,
      members,
    });
  };

  public watchChannel = async ({
    channel,
  }: {
    channel: Channel;
  }): Promise<ChannelAPIResponse> => {
    return await channel.watch();
  };

  public getChannels = async ({
    members,
  }: {
    members: string[];
  }): Promise<(Channel | any)[]> => {
    const filter = {members: {$in: members}};
    return await chatClient.queryChannels(filter, {last_message_at: -1}, {});
  };

  public getChannelByID = async ({id}: {id: string}): Promise<Channel> => {
    const filter = {id: {$in: [id]}};
    const channels = await chatClient.queryChannels(filter, {});
    return channels[0];
  };

  public hideChannel = async ({
    channel,
  }: {
    channel: Channel;
  }): Promise<APIResponse> => {
    return await channel.hide(null, true);
  };

  public archiveChannel = async ({
    channel,
  }: {
    channel: Channel;
  }): Promise<APIResponse> => {
    return await channel.hide();
  };

  public sendMessage = async ({
    channel,
    ...rest
  }: {
    channel: Channel;
    text: string;
    quoted_message_id?: string;
    attachments: Attachment[];
  }): Promise<
    APIResponse & {
      message: MessageResponse<
        UnknownType,
        UnknownType,
        string,
        UnknownType,
        UnknownType,
        UnknownType
      >;
    }
  > => {
    return await channel.sendMessage({
      ...rest,
    });
  };
}

export const ChannelService = Object.freeze(new ChannelServiceClass());
